// 공유 캡션 — Share 누를 때 클립보드에 박아 SNS에 붙여넣게 한다(영상/이미지 파일과 별개로).
// 네이티브 플러그인 없이 web clipboard API만 사용 → OTA로 배포 가능.

import { ARCHETYPE_NAME } from "../i18n/strings";
import type { Archetype, Lang } from "./types";

const URL = "https://bwek.app";

/** 언어별 공유 문구. {score}·{type}(EN만) 채움 + URL + 해시태그. */
export function shareCaption(lang: Lang, score: number, archetype: Archetype): string {
  const s = Math.round(score);
  if (lang === "ja") {
    return `【bwek採点】理不尽${s}点。丸めて捨てた。慰めは不要。${URL} #bwek採点`;
  }
  if (lang === "en") {
    const type = ARCHETYPE_NAME[archetype]?.en ?? "";
    return `bwek score: ${s}, ${type}. crumpled and gone. unbothered. ${URL} #bwekscore`;
  }
  return `【bwek 채점】오늘의 어이없음 ${s}점. 구겨서 버렸음. 위로는 사양. ${URL} #bwek채점`;
}

/** 클립보드 복사(best-effort). Clipboard API → 실패 시 textarea+execCommand 폴백. */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* 폴백 시도 */
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    ta.remove();
    return ok;
  } catch {
    return false;
  }
}
